import { useEffect } from 'react';

const SITE = '미라이쥬쿠';
const DEFAULT_DESC =
  '일본 대학 입시 요강·EJU·일반입시·국비 루트를 단순하고 명확하게. 참고용이며 원문 확인이 우선입니다.';

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * 페이지별 title / description / OG (CRA, 의존성 없이)
 */
export function usePageMeta({
  title,
  description = DEFAULT_DESC,
  path = '',
  type = 'website',
} = {}) {
  useEffect(() => {
    const fullTitle =
      title === null || title === undefined || title === ''
        ? `${SITE} — 일본 입시 요강`
        : `${title} · ${SITE}`;
    document.title = fullTitle;

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:site_name', SITE);
    setMeta('name', 'twitter:card', 'summary');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);

    const url = path
      ? `https://miraijuken.net${path.startsWith('/') ? path : `/${path}`}`
      : 'https://miraijuken.net/';
    setMeta('property', 'og:url', url);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [title, description, path, type]);
}

export const defaultDescription = DEFAULT_DESC;
